import React from 'react';
import { connect } from 'react-redux';
import modeType from '../../../constants/ModeConstants';
import shapeType from '../../../constants/ShapeConstants';
import { changeRichTextContent, changeShapeFillColor, changeShapeFillVisibility, changeShapeStrokeColor, changeShapeStrokeOpacity, changeShapeType, changeStrokeSize, changeTextLineHeight } from '../../../actions/CurrentSlideActions';
import { changeContextMode, expandFontLineHeight, expandFontSizeList, expandFontsList, refreshTextEditorTool } from '../../../actions/MenuActions';
import properties from '../../../constants/Properties';
import mouseUtils from '../../utils/MouseUtils';
import appParameters from '../../utils/AppParameters';
import storeManager from '../../../store/StoreManager';
import saveManager from '../../utils/SaveManager';
import hoverManager from '../../utils/HoverManager';
import locales from '../../../locales/LocalesManager';
import { EditTextArea } from '../textEditorTool/components/EditTextArea';
import { TextBoxArea } from '../textEditorTool/components/TextBoxArea';
import { CollorButtonsArea } from '../textEditorTool/components/CollorButtonsArea';
import textEditorUtils from './utils/TextEditorUtils';
import { InsertImageArea } from './components/InsertImageArea';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 10,
            top: this.props.topPosition
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        let text;
        let rightElement;

        if (this.props.topPosition === 0 && !this.props.insertImage) {
            let closeButtonStyle = {
                position: 'absolute',
                right: 18,
                top: 4,
                width: 22,
                height: 22,
                cursor: 'pointer',
                userDrag: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                background: 'none',
                borderStyle: 'none',
                margin: 0,
                padding: 0,
                boxSizing: 'initial',
                fontSize: 'initial'
            };

            const closeStyle = {
                position: 'absolute',
                width: 15,
                top: 4,
                right: 4,
                cursor: 'pointer',
                zIndex: 1000
            };

            text = hoverManager.getText('editText');

            rightElement = <button id="firstFocusableObjectForTextEditorTool" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
            </button>;
        } else {
            const iconStyle = {
                position: 'absolute',
                width: 15,
                top: 7,
                right: 20,
                cursor: 'default',
                color: 'white'
            };

            if (this.props.insertImage)
                text = hoverManager.getText('insertImageTitle');
            else
                text = hoverManager.getText('editTextElement');

            rightElement = <i style={iconStyle} className='fa fa-angle-down'></i>;
        }

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{text}</span>
                {rightElement}
            </div>
        );
    }
});

const TextEditorToolContent = React.createClass({
    getInitialState() {
        return {
            fontColorsExpanded: false,
            shapeType: this.props.contextTarget.type,
            fillStrokeMenu: 'none'
        };
    },
    componentDidMount() {
        this.checkDefaultFont();

        document.addEventListener('keydown', this.onKeyDownHandler);
    },
    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDownHandler);
    },
    onKeyDownHandler(e) {
        if (e.keyCode === 9 || e.keyCode === 13) // TAB or ENTER
            return;

        if (textEditorUtils.selectedTextShape === '')
            return;

        if (document.activeElement.id && document.activeElement.id.indexOf('text_area_' + textEditorUtils.selectedTextShape) != -1)
            return;
        
        if (e.keyCode === 27) { // Escape
            this.props.dispatch(expandFontsList(false));
            this.props.dispatch(expandFontSizeList(false));
            this.props.dispatch(expandFontLineHeight(false));

            this.setTextFocus();
        } else if (textEditorUtils.isPrintableCharacter(e.keyCode)) { // printable character
            this.props.dispatch(expandFontsList(false));
            this.props.dispatch(expandFontSizeList(false));
            this.props.dispatch(expandFontLineHeight(false));

            this.setTextFocus({key: e.key, keyCode: e.keyCode});
        }
    },
    checkDefaultFont() {
        // Force styling with css
        try {
            document.execCommand("styleWithCSS", false, true);
        } catch (e) {
            try {
                document.execCommand("useCSS", false, true);
            } catch (er) {
            }
        }

        this.executeButtonCommand(14, textEditorUtils.currentFont); // set font to the current one ... Cabin is default if nothing was set on a new production
        this.executeButtonCommand(16, textEditorUtils.currentFontSize, true);
    },
    onEditorClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const target = e.target;

        if (!(this.hasParentWithId(target, 'fontsMenu', 6) === true || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent'))
            this.props.dispatch(expandFontsList(false));

        if (!(this.hasParentWithId(target, 'fontSizeMenu', 6) === true || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent'))
            this.props.dispatch(expandFontSizeList(false));

        if (!(this.hasParentWithId(target, 'fontLineHeightMenu', 3) === true || target.className === 'lineHeightButton' || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent'))
            this.props.dispatch(expandFontLineHeight(false));
    },
    hasParentWithId(target, parentId, level) {
        if (target.id === parentId)
            return true;

        let i;

        for (i=0; i<level; i++) {
            if (target.parentNode === undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id === parentId)
                    return true;
            }
        }

        return false;
    },
    forceUpdateTextEditor(value) {
        if (value && value.length > 0) {
            this.setState({
                fillStrokeMenu: value
            });
        }

        setTimeout(function() {
            this.forceUpdate();
        }.bind(this), 5);
    },
    setTextFocus(keyboardCharacter) {
        setTimeout(function() {
            let textArea = document.getElementById('text_area_' + this.props.contextTarget.uuid);

            if (textArea) {
                textArea.focus();

                if (keyboardCharacter)
                    textEditorUtils.setCursorAtLastPosition(textArea, this.props.contextTarget, keyboardCharacter);
            }
        }.bind(this), 5);
    },
    getContextTarget() {
        let shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.contextTarget.uuid)
                return shapes[i];
        }

        return this.props.contextTarget;
    },
    executeChangeShapeTypeCommand(uuid, type) {
        textEditorUtils.resetActions();

        if (type === this.state.type)
            return;

        let textArea = document.getElementById('text_area_' + uuid);

        textEditorUtils.saveSelection(textArea);

        if (textArea) {
            const newValue = textArea.innerHTML;

            if (newValue != undefined) {
                this.props.dispatch(changeRichTextContent(uuid, newValue));
                saveManager.isContentChanged(true);
            }
        }

        setTimeout(function() {
            this.props.dispatch(changeShapeType(uuid, type));

            setTimeout(function() {
                this.props.dispatch(refreshTextEditorTool());
                this.forceUpdateTextEditor();

                textEditorUtils.restoreSelection(document.getElementById('text_area_' + uuid));
                this.checkDefaultFont();
            }.bind(this), 30);
        }.bind(this), 5);

        this.setState({
            shapeType: type
        });
    },
    executeColorPickerCommand(type, value) {
        let contextTarget = this.getContextTarget();

        switch(type) {
            case 'changeShapeFillVisibility': {
                this.props.dispatch(changeShapeFillVisibility(contextTarget.uuid, false));
                break;
            }
            case 'changeShapeFillColor': {
                this.props.dispatch(changeShapeFillVisibility(contextTarget.uuid, true));
                this.props.dispatch(changeShapeFillColor(contextTarget, value));
                break;
            }
            case 'changeShapeStrokeOpacity': {
                this.props.dispatch(changeShapeStrokeOpacity(contextTarget, 0));
                break;
            }
            case 'changeShapeStrokeColor': {
                this.props.dispatch(changeShapeStrokeColor(contextTarget, value));
                break;
            }
            case 'changeFontColor': {
                this.executeButtonCommand(17, value);
                break;
            }
            case 'changeStrokeSize': {
                if (contextTarget.strokeWidth != value)
                    this.props.dispatch(changeStrokeSize(contextTarget, value));
                break;
            }
        }

        this.forceUpdateTextEditor();
    },
    executeButtonCommand(index, value, useCurrentFontSize = false) {
        switch(index) {
            // line 1
            case 0: { // open Font color pallete
                break;
            }

            case 1: { // bold
                document.execCommand('bold', false, undefined);
                break;
            }
            case 2: { // italic
                document.execCommand('italic', false);
                break;
            }
            case 3: { // underline
                document.execCommand('underline', false);
                break;
            }

            case 4: { // left aling
                document.execCommand('justifyleft', false, undefined);
                break;
            }
            case 5: { // center aling
                document.execCommand('justifycenter', false, undefined);
                break;
            }
            case 6: { // right aling
                document.execCommand('justifyright', false, undefined);
                break;
            }

            // line 2
            case 7: { // ordered list
                document.execCommand('insertorderedlist', false);
                break;
            }
            case 8: { // point list
                document.execCommand('insertunorderedlist', false);
                break;
            }
            case 9: { // increase indent
                document.execCommand('indent', false);
                break;
            }
            case 10: { // decrease indent
                document.execCommand('outdent', false);
                break;
            }

            case 11: { // superscript
                document.execCommand('superscript', false);
                break;
            }
            case 12: { // subscript
                document.execCommand('subscript', false);
                break;
            }

            case 13: { // show Line height menu
                const isExpanded = !this.props.fontLineHeightIsExpanded;
                this.props.dispatch(expandFontLineHeight(isExpanded));
                break;
            }

            // line 0
            case 14: { // font family
                textEditorUtils.currentFont = value;
                document.execCommand('fontname', false, value);
                break;
            }

            case 15: // decrease font
            case 16: { // increase font or add it from the expanded list
                let currentFontSize = useCurrentFontSize ? value : textEditorUtils.getCommandValue('fontsize');
                let selection = window.getSelection();

                textEditorUtils.currentFontSize = currentFontSize;
                textEditorUtils.updateSize = false;

                document.execCommand('fontsize', false, '7'); // values from 1 to 7

                if (selection.anchorOffset === selection.extentOffset) { // no text selected and only the cursor pointer
                    textEditorUtils.updateSize = true; // update shape size only when fontSize attribute is set properly
                } else { // at least 1 character selected
                    let currentElement = selection.anchorNode.parentNode;
                    currentElement.removeAttribute('size');
                    currentElement.style.fontSize = currentFontSize + 'px';

                    textEditorUtils.updateSize = true; // update shape size only when fontSize attribute is set properly
                    textEditorUtils.updateShapeSize(this.props.contextTarget, this.props.dispatch);
                }

                break;
            }

            case 17: { // font color
                document.execCommand('forecolor', false, value);
                break;
            }

            case 18: { // change line height
                this.props.dispatch(changeTextLineHeight(this.props.contextTarget.uuid, value));

                setTimeout(function() {
                    textEditorUtils.updateShapeSize(this.getContextTarget(), this.props.dispatch); // get new shapeModel from the main state after the lineHeight is changed
                }.bind(this), 1);
                break;
            }
        }

        this.forceUpdateTextEditor();
    },
    checkFontColors(value) {
        this.setState({
            fontColorsExpanded: value
        });
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const target = this.getContextTarget();
        const topExtraPadding = 5;
        const gridSize = 34;
        const lineElementTopPadding = 15;
        const lineHeight = gridSize + lineElementTopPadding;
        let leftGap = (this.props.accordionWidth - 9 * gridSize) / 2;
        let width = this.props.accordionWidth - 2 * leftGap;
        let palleteColorHeight = this.state.fontColorsExpanded ? (2 * gridSize + 2 * lineElementTopPadding) : 0;
        let topHolderHeight = 3 * lineHeight + palleteColorHeight + lineElementTopPadding;

        const fillStrokeMenuHolder = {
            position: 'absolute',
            top: 2 * properties.CLIPART_BUTTON_HEIGHT + topExtraPadding + topHolderHeight,
            left: leftGap,
            width: width
        };

        let elementWidth = Math.floor(width / 6);
        let collorButtonsAreaTop = elementWidth + 2 * lineElementTopPadding;
        let insertImageHolder;

        if (target.type === shapeType.COMPLEX_SPEAK_BUBBLE && target.isMindMap) {
            let insertImageHolderTop = fillStrokeMenuHolder.top + 143;

            if (this.state.fillStrokeMenu === 'changeShapeFillColor')
                insertImageHolderTop = insertImageHolderTop + 72;
            else
            if (this.state.fillStrokeMenu === 'changeShapeStrokeColor')
                insertImageHolderTop = insertImageHolderTop + 130;

            let insertImageHolderStyle = {
                position: 'absolute',
                top: insertImageHolderTop,
                width: this.props.accordionWidth
            };

            insertImageHolder =
                <div style={insertImageHolderStyle}>
                    <Title accordionWidth={this.props.accordionWidth} topPosition={0} insertImage={true} />
                    <InsertImageArea top={properties.CLIPART_BUTTON_HEIGHT + lineElementTopPadding} width={this.props.accordionWidth} gridSize={gridSize} contextTarget={target} forceUpdateTextEditor={this.forceUpdateTextEditor}/>
                </div>;
        }

        return (
            <div id="textEditorTool" style={menuStyle} onTouchStart={this.onEditorClick} onMouseDown={this.onEditorClick}>
                <Title accordionWidth={this.props.accordionWidth} topPosition={0} dispatch={this.props.dispatch} />
                <EditTextArea width={width} height={topHolderHeight} top={properties.CLIPART_BUTTON_HEIGHT + topExtraPadding} gridSize={gridSize} lineElementTopPadding={lineElementTopPadding} gap={leftGap} palleteColorHeight={palleteColorHeight} checkFontColors={this.checkFontColors} executeCommand={this.executeButtonCommand} executeColorPickerCommand={this.executeColorPickerCommand} fontLineHeightIsExpanded={this.props.fontLineHeightIsExpanded} contextTarget={target} forceUpdateTextEditor={this.forceUpdateTextEditor}/>
                <Title accordionWidth={this.props.accordionWidth} topPosition={properties.CLIPART_BUTTON_HEIGHT + topExtraPadding + topHolderHeight} />
                <div style={fillStrokeMenuHolder}>
                    <TextBoxArea executeCommand={this.executeChangeShapeTypeCommand} width={width} topGap={lineElementTopPadding} elementWidth={elementWidth} contextTarget={target} />
                    <CollorButtonsArea top={collorButtonsAreaTop} width={width} topGap={lineElementTopPadding} gridSize={gridSize} forceUpdateTextEditor={this.forceUpdateTextEditor} executeCommand={this.executeColorPickerCommand} contextTarget={target} dispatch={this.props.dispatch} />
                </div>

                {insertImageHolder}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const refreshTextEditorTool = state.menu.refreshTextEditorTool;
    const fontLineHeightIsExpanded = state.menu.fontLineHeightIsExpanded;

    return {
        refreshTextEditorTool,
        fontLineHeightIsExpanded
    };
}

export const TextEditorTool = connect(mapStateToProps)(TextEditorToolContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/TextEditorTool.js
 **/